module.exports = __webpack_public_path__ + "img/noGroupsAdded.d7865045.svg";